module.exports = __webpack_public_path__ + "static/img/news76_4.0bc593f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/news/img/detail/activity/news76/news76_4.webp
// module id = yGCi
// module chunks = 0